import {Component, input} from '@angular/core';
import {Screen} from "../../../../../../models/screen.model";
import {
  PlanningRegionAddReservationModalComponent
} from "../../../../../../shared/modals/planning-region/planning-region-add-reservation-modal/planning-region-add-reservation-modal.component";
import {PlanningRegion} from "../../../../../../models/planning_region.model";
import {NgbDateStruct, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { dateUtils } from '../../../../../../helpers/date.utils';
import {PlanningRegionService} from "../../../../../../services/planning-region.service";

@Component({
  selector: '[app-planning-region-empty-cell]',
  standalone: true,
  imports: [],
  templateUrl: './planning-region-empty-cell.component.html',
  styleUrl: './planning-region-empty-cell.component.scss'
})
export class PlanningRegionEmptyCellComponent {
  screen = input.required<Screen>();
  data = input.required<PlanningRegion>()
  dateValue = input.required<NgbDateStruct>()
  wednesday = input.required<string>()

  constructor(private modalService: NgbModal,
              protected planningRegionService: PlanningRegionService) {
  }

  public openEmptyProgrammeModal(): void {
    if (this.data().cinemas && this.data().cinemas.length > 0 && this.wednesday()) {
      const modalRef = this.modalService.open(PlanningRegionAddReservationModalComponent,
        {
          size: 'lg',
          centered: true,
        }
      );
      modalRef.componentInstance.cinema = this.data().cinemas.filter(cinema => cinema.id_cinema == this.screen().id_cinema)[0];
      modalRef.componentInstance.screen = this.screen();
      modalRef.componentInstance.date = dateUtils.parseDateToNgbDateStruct(this.wednesday());
      modalRef.componentInstance.title = 'addReservationModal.modalHeader.title';
    }
  }
}
